export default "__VITE_ASSET__Dv6kPCcv__"